import React from "react";
import HTMLParser from "../../htmlParser";
import decodeHTMLEntities from "../../../utils/decodeHTMLentities";
import { Link } from "gatsby";
const PostTitle = (props) => {
    const classNames = ((attributes) => {
        let className = ["wp-block-heading"];
        if (attributes.align === "full") {
            className.push("alignfull");
        }
        if (attributes.textAlign) {
            className.push("has-text-align-" + attributes.textAlign);
        }
        if (attributes.backgroundColor) {
            className.push("has-" + attributes.backgroundColor + "-background-color");
        }
        if (attributes.className) {
            className.push(attributes.className);
        }
        return className.join(" ");
    })(props.attributes);
    const TagLevel = "h" + (props.level || props.attributes.level || 2);
    const InnerContent = () => {
        return React.createElement(HTMLParser, null, props.children);
    };
    const LinkWrapper = () => {
        return props.attributes.isLink && props.uri ? (React.createElement(Link, { to: props.uri, target: props.attributes.linkTarget, title: "Lire l'actualité " + decodeHTMLEntities(props.title) },
            React.createElement(InnerContent, null))) : (React.createElement(InnerContent, null));
    };
    return (React.createElement(TagLevel, { className: classNames },
        React.createElement(LinkWrapper, null)));
};
PostTitle._ges_name = "PostTitle";
export default PostTitle;
